import React, { useState, useEffect } from 'react'
import { TopBarSection, TopBarTitle, WidgetContent, TopBar, TopBarLinkContainer } from '@duik/it'
import { Link } from 'react-router-dom'
import cls from '../../styles/Header.scss'
import MainContainer from '../../UI/MainContainer'
import TableContainer from '../../UI/TableContainer'
import TopBarMenuDivider from '../../UI/TopBarMenuDivider'
import LineGraph from './LineGraph'
import GroupedBarGraph from './GroupedBarGraph'
import BarColors from './BarColors'
import LoadingContainer from 'UI/LoadingContainer'
import { api } from '../../Controllers/api'

const HaulGraphs = props => {
  const [activeTab, setActiveTab] = useState('driveTime')
  const [graphTimeScale, setGraphTimeScale] = useState('Month-Day')
  const [byDayGraphs, setByDayGraphs] = useState()
  const [byHourGraphs, setByHourGraphs] = useState()
  const [projectName, setProjectName] = useState()
  const [visibleGraphData, setVisibleGraphData] = useState()
  const [yAxis, setYAxis] = useState('Average Minutes')
  const [currentGraphRef, setCurrentGraphRef] = useState()

  const selectedProject = props.match.params.projectNumber
  const selectedHaul = props.match.params.haulId

  const graphCodeMap = {
    driveTime: {
      header: 'Time Driving',
      units: 'Average Minutes'
    },
    siteTime: {
      header: 'Time at Pick Up',
      units: 'Average Minutes'
    },
    dumpTime: {
      header: 'Time at Drop Off',
      units: 'Average Minutes'
    },
    productionRate: {
      header: 'Production Rate'
    },
    productionTotal: {
      header: 'Production Total'
    },
    productionRateByTruck: {
      header: 'Production Rate by Truck Type'
    }
  }

  useEffect(() => {
    api.get(`dashboard/haulGraphs/${selectedHaul}`).then(({ data }) => {
      const { byDayGraphs, byHourGraphs } = data
      if (byDayGraphs) {
        setByDayGraphs(byDayGraphs)
        BarColors.setTruckColors(Object.keys(byDayGraphs.productionRateByTruckGraph.datasets))
        setByHourGraphs(byHourGraphs)
        setVisibleGraphData(byDayGraphs)
      }
    })
  }, []) //eslint-disable-line

  useEffect(() => {
    if (props.projectList) {
      const projectObj = props.projectList.find(
        ({ projectNumber }) => projectNumber === selectedProject
      )
      setProjectName(projectObj.projectName.replace(/\s/g, '\xa0') + '\xa0')
    }
  }, [props.projectList]) //eslint-disable-line

  const storeGraphRef = ref => {
    setCurrentGraphRef(ref)
  }

  const graphNav = code => {
    if (activeTab !== code && byDayGraphs) {
      currentGraphRef.destroy()
      if (code.includes('productionRate')) {
        setYAxis(`Average ${byDayGraphs.productionUnits} per Trip`)
      } else if (code === 'productionTotal') {
        setYAxis(`Average ${byDayGraphs.productionUnits}`)
      } else setYAxis(graphCodeMap[code].units)
    }
    setActiveTab(code)
  }

  const clickedDay = chartElement => {
    if (chartElement) {
      const date = visibleGraphData.labels[chartElement._index]
      currentGraphRef.destroy()
      setVisibleGraphData(byHourGraphs[date])
      setGraphTimeScale(`${date} Hours`)
    }
  }

  const backToMonthView = () => {
    currentGraphRef.destroy()
    setVisibleGraphData(byDayGraphs)
    setGraphTimeScale(`Month-Day`)
  }

  return (
    <MainContainer>
      <div style={{ width: '100%' }}>
        <TopBar>
          <TopBarSection>
            <Link to="/app/dashboard" style={{ textDecoration: 'none' }}>
              <h2 className="uik-top-bar-title__wrapper" style={{ paddingLeft: '25px' }}>
                Dashboard
              </h2>
            </Link>
            <h2 className="uik-top-bar-title__wrapper">&nbsp;{'>'}&nbsp;</h2>
            {projectName ? (
              <>
                <Link
                  to={`/app/dashboard/${selectedProject}/hauls`}
                  style={{ textDecoration: 'none', marginTop: 0 }}
                >
                  <h2 className="uik-top-bar-title__wrapper">{projectName}Hauls</h2>
                </Link>
                <h2 className="uik-top-bar-title__wrapper">&nbsp;{'>'}&nbsp;</h2>
                <h2 className="uik-top-bar-title__wrapper" style={{ color: '#289C91' }}>
                  {selectedHaul}
                </h2>
              </>
            ) : null}
          </TopBarSection>
        </TopBar>
      </div>
      <TableContainer>
        <WidgetContent style={{ padding: '8px 0px' }}>
          <TopBarSection style={{ padding: '0px 30px' }}>
            <TopBarTitle>{selectedHaul}</TopBarTitle>
            <TopBarMenuDivider />
          </TopBarSection>
        </WidgetContent>
        <WidgetContent style={{ padding: '8px 0px' }}>
          <TopBarSection>
            <TopBarLinkContainer
              style={{ width: '100%', display: 'flex', justifyContent: 'space-around' }}
              className={cls.links}
            >
              {Object.keys(graphCodeMap).map(code => {
                return (
                  <span
                    key={code}
                    onClick={() => graphNav(code)}
                    style={{ fontSize: '16px' }}
                    className={`uik-top-bar-link__wrapper ${
                      activeTab === code ? 'active dashboard-haulGraphs-nav-active' : null
                    }`}
                  >
                    {graphCodeMap[code].header}
                  </span>
                )
              })}
            </TopBarLinkContainer>
          </TopBarSection>
        </WidgetContent>
        <div
          onClick={() => {
            if (graphTimeScale !== 'Month-Day') backToMonthView()
          }}
        >
          <div className="dashboard-haulGraphs-helpText">
            {graphTimeScale === 'Month-Day'
              ? 'Click on a day for hourly detail'
              : 'Click anywhere for monthly detail'}
          </div>
          <div className="dashboard-haulGraphs-canvas">
            {visibleGraphData ? (
              activeTab !== 'productionRateByTruck' ? (
                <LineGraph
                  labels={visibleGraphData.labels}
                  data={visibleGraphData[`${activeTab}Graph`].data}
                  storeGraphRef={storeGraphRef}
                  toolTipLabel={graphCodeMap[activeTab].header}
                  yAxesLabel={yAxis}
                  xAxesLabel={graphTimeScale}
                  clickedDay={clickedDay}
                  backToMonthView={backToMonthView}
                />
              ) : (
                <GroupedBarGraph
                  labels={visibleGraphData.labels}
                  datasets={visibleGraphData[`${activeTab}Graph`].datasets}
                  storeGraphRef={storeGraphRef}
                  toolTipLabel={graphCodeMap[activeTab].header}
                  yAxesLabel={yAxis}
                  xAxesLabel={graphTimeScale}
                  clickedDay={clickedDay}
                  backToMonthView={backToMonthView}
                />
              )
            ) : (
              <LoadingContainer />
            )}
          </div>
        </div>
      </TableContainer>
    </MainContainer>
  )
}

export default HaulGraphs
